import { Routes, RouterModule } from "@angular/router";
import { MemberListComponent } from "./member/member-list/member-list.component";
import { NewAdminRedirectComponent } from "./new-admin-redirect/new-admin-redirect.component";
import { MemberEditComponent } from "./member/member-edit/member-edit.component";
import { MembersForVerificationComponent } from "./member/members-for-verification/members-for-verification.component";
import { VerificationCodesComponent } from "./member/verification-codes/verification-codes.component";
import { PromoCodeListingComponent } from "./promo-code/promo-code-listing/promo-code-listing.component";
import { PromoCodeEditComponent } from "./promo-code/promo-code-edit/promo-code-edit.component";
import { DashboardComponent } from "./dashboard/dashboard/dashboard.component";
import { LoginComponent } from "./auth/login/login.component";
import { ForgottenPasswordComponent } from "./auth/forgotten-password/forgotten-password.component";
import { AdminComponent } from "./core/admin/admin.component";
import { AuthGuard } from "./auth/guard/auth.guard";
import { LoggedInGuard } from "./auth/guard/logged.guard";
import { ReportListingComponent } from "./reports/report-listing/report-listing.component";
import { SubscriptionPlansListingComponent } from "./subscription-plans/subscription-plans-listing/subscription-plans-listing.component";
import { SubscriptionPlansEditComponent } from "./subscription-plans/subscription-plans-edit/subscription-plans-edit.component";
import { CouponsEditComponent } from "./coupons/coupons-edit/coupons-edit.component";
import { CouponsListingComponent } from "./coupons/coupons-listing/coupons-listing.component";
import { TotpComponent } from "./auth/totp/totp.component";
import { TotpGuard } from "./auth/guard/totp.guard";
import { ExternalSessionGuard } from "./auth/guard/external-session.guard";
import { AppComponent } from "./app.component";
import { ReferralProgramsListComponent } from "./referrals/programs/programs-list.component";
import { ReferralProgramsEditComponent } from "./referrals/programs/programs-edit.component";
import { ReferralRewardsEditComponent } from "./referrals/rewards/rewards-edit.component";

const appRoutes: Routes = [
  {
    path: "",
    component: AppComponent,
    canActivate: [ExternalSessionGuard],
    children: [
      {
        path: "login",
        component: LoginComponent,
        canActivate: [LoggedInGuard],
      },
      {
        path: "forgotten-password",
        component: ForgottenPasswordComponent,
        canActivate: [LoggedInGuard],
      },
      {
        path: "not-found",
        component: NewAdminRedirectComponent,
      },
      {
        path: "2fa",
        component: TotpComponent,
        canActivate: [TotpGuard],
      },
      { path: "", redirectTo: "/admin/dashboard", pathMatch: "full" },
      {
        path: "admin",
        component: AdminComponent,
        children: [
          {
            path: "",
            redirectTo: "/admin/dashboard",
            pathMatch: "full",
          },
          {
            path: "dashboard",
            component: DashboardComponent,
            canActivate: [AuthGuard],
          },
          {
            path: "members/edit",
            component: MemberEditComponent,
            canActivate: [AuthGuard],
          },
          {
            path: "members",
            component: MemberListComponent,
            canActivate: [AuthGuard],
          },
          {
            path: "members-for-verification",
            component: MembersForVerificationComponent,
            canActivate: [AuthGuard],
          },
          {
            path: "verification-codes",
            component: VerificationCodesComponent,
            canActivate: [AuthGuard],
          },
          {
            path: "offers/add",
            component: NewAdminRedirectComponent,
            data: { pageTitle: "Add Offer", pagePath: "/offers/new" },
            canActivate: [AuthGuard],
          },
          {
            path: "offers/edit",
            component: NewAdminRedirectComponent,
            data: { pageTitle: "Edit Offer", pagePath: "/offers" },
            canActivate: [AuthGuard],
          },
          {
            path: "offers",
            component: NewAdminRedirectComponent,
            data: { pageTitle: "Offers", pagePath: "/offers" },
            canActivate: [AuthGuard],
          },
          {
            path: "offer/advertise",
            component: NewAdminRedirectComponent,
            data: { pageTitle: "Notifications", pagePath: "/notifications" },
            canActivate: [AuthGuard],
          },
          {
            path: "offer-redemptions",
            component: NewAdminRedirectComponent,
            data: { pageTitle: "Offer Redemptions", pagePath: "/offers?section=performance" },
            canActivate: [AuthGuard],
          },
          {
            path: "reports",
            component: ReportListingComponent,
            canActivate: [AuthGuard],
          },
          {
            path: "profile",
            component: NewAdminRedirectComponent,
            data: { pageTitle: "Profile", pagePath: "/account" },
            canActivate: [AuthGuard],
          },
          {
            path: "admin-users/edit",
            component: NewAdminRedirectComponent,
            data: { pageTitle: "Admin Users", pagePath: "/admin-users" },
            canActivate: [AuthGuard],
          },
          {
            path: "admin-users/add",
            component: NewAdminRedirectComponent,
            data: { pageTitle: "Admin Users", pagePath: "/admin-users" },
            canActivate: [AuthGuard],
          },
          {
            path: "admin-users",
            component: NewAdminRedirectComponent,
            data: { pageTitle: "Admin Users", pagePath: "/admin-users" },
            canActivate: [AuthGuard],
          },
          {
            path: "notifications",
            component: NewAdminRedirectComponent,
            data: { pageTitle: "Notifications", pagePath: "/notifications" },
            canActivate: [AuthGuard],
          },
          {
            path: "offer-types/manage-icons",
            component: NewAdminRedirectComponent,
            data: { pageTitle: "Offer Types", pagePath: "/venue-types" },
            canActivate: [AuthGuard],
          },
          {
            path: "offer-types/edit",
            component: NewAdminRedirectComponent,
            data: { pageTitle: "Offer Types", pagePath: "/venue-types" },
            canActivate: [AuthGuard],
            pathMatch: "full",
          },
          {
            path: "offer-types/add",
            component: NewAdminRedirectComponent,
            data: { pageTitle: "Offer Types", pagePath: "/venue-types" },
            canActivate: [AuthGuard],
            pathMatch: "full",
          },
          {
            path: "offer-types",
            component: NewAdminRedirectComponent,
            data: { pageTitle: "Offer Types", pagePath: "/venue-types" },
            canActivate: [AuthGuard],
            pathMatch: "full",
          },
          {
            path: "offer-tags/add",
            component: NewAdminRedirectComponent,
            data: { pageTitle: "Offer Tags", pagePath: "/offer-tags" },
            canActivate: [AuthGuard],
            pathMatch: "full",
          },
          {
            path: "offer-tags",
            component: NewAdminRedirectComponent,
            data: { pageTitle: "Offer Tags", pagePath: "/offer-tags" },
            canActivate: [AuthGuard],
          },
          // Legacy browser URLs remain available for existing promo-code bookmarks.
          {
            path: "membership-codes/edit",
            component: PromoCodeEditComponent,
            canActivate: [AuthGuard],
          },
          {
            path: "membership-codes/add",
            component: PromoCodeEditComponent,
            canActivate: [AuthGuard],
          },
          {
            path: "membership-codes",
            component: PromoCodeListingComponent,
            canActivate: [AuthGuard],
          },
          {
            path: "pages/edit",
            component: NewAdminRedirectComponent,
            data: { pageTitle: "FAQ", pagePath: "/faq" },
            canActivate: [AuthGuard],
          },
          {
            path: "pages/add",
            component: NewAdminRedirectComponent,
            data: { pageTitle: "FAQ", pagePath: "/faq" },
            canActivate: [AuthGuard],
          },
          {
            path: "pages",
            component: NewAdminRedirectComponent,
            data: { pageTitle: "FAQ", pagePath: "/faq" },
            canActivate: [AuthGuard],
          },
          {
            path: "sponsors/edit",
            component: NewAdminRedirectComponent,
            data: { pageTitle: "Sponsors", pagePath: "/sponsors" },
            canActivate: [AuthGuard],
            pathMatch: "full",
          },
          {
            path: "sponsors/add",
            component: NewAdminRedirectComponent,
            data: { pageTitle: "Sponsors", pagePath: "/sponsors" },
            canActivate: [AuthGuard],
            pathMatch: "full",
          },
          {
            path: "sponsors",
            component: NewAdminRedirectComponent,
            data: { pageTitle: "Sponsors", pagePath: "/sponsors" },
            canActivate: [AuthGuard],
            pathMatch: "full",
          },
          {
            path: "whitelisted-domains/edit",
            component: NewAdminRedirectComponent,
            data: { pageTitle: "Whitelisted Domains", pagePath: "/whitelisted-domains" },
            canActivate: [AuthGuard],
            pathMatch: "full",
          },
          {
            path: "whitelisted-domains/add",
            component: NewAdminRedirectComponent,
            data: { pageTitle: "Whitelisted Domains", pagePath: "/whitelisted-domains" },
            canActivate: [AuthGuard],
            pathMatch: "full",
          },
          {
            path: "whitelisted-domains",
            component: NewAdminRedirectComponent,
            data: { pageTitle: "Whitelisted Domains", pagePath: "/whitelisted-domains" },
            canActivate: [AuthGuard],
            pathMatch: "full",
          },
          {
            path: "subscription-plans/add",
            component: SubscriptionPlansEditComponent,
            canActivate: [AuthGuard],
            pathMatch: "full",
          },
          {
            path: "subscription-plans/edit",
            component: SubscriptionPlansEditComponent,
            canActivate: [AuthGuard],
            pathMatch: "full",
          },
          {
            path: "subscription-plans",
            component: SubscriptionPlansListingComponent,
            canActivate: [AuthGuard],
          },
          {
            path: "coupons/add",
            component: CouponsEditComponent,
            canActivate: [AuthGuard],
            pathMatch: "full",
          },
          {
            path: "coupons",
            component: CouponsListingComponent,
            canActivate: [AuthGuard],
          },
          {
            path: "emails",
            component: NewAdminRedirectComponent,
            data: { pageTitle: "Emails", pagePath: "/emails" },
            canActivate: [AuthGuard],
          },
          {
            path: "ab-tests/add",
            component: NewAdminRedirectComponent,
            data: { pageTitle: "AB Tests", pagePath: "/ab-tests" },
            canActivate: [AuthGuard],
            pathMatch: "full",
          },
          {
            path: "ab-tests/edit",
            component: NewAdminRedirectComponent,
            data: { pageTitle: "AB Tests", pagePath: "/ab-tests" },
            canActivate: [AuthGuard],
            pathMatch: "full",
          },
          {
            path: "ab-tests",
            component: NewAdminRedirectComponent,
            data: { pageTitle: "AB Tests", pagePath: "/ab-tests" },
            canActivate: [AuthGuard],
            pathMatch: "full",
          },
          {
            path: "referral-programs",
            component: ReferralProgramsListComponent,
            canActivate: [AuthGuard],
          },
          {
            path: "referral-programs/edit",
            component: ReferralProgramsEditComponent,
            canActivate: [AuthGuard],
          },
          {
            path: "referral-rewards/edit",
            component: ReferralRewardsEditComponent,
            canActivate: [AuthGuard],
          },
          {
            path: "exit-survey",
            component: NewAdminRedirectComponent,
            data: { pageTitle: 'Exit surveys', pagePath: '/members?section=exit-surveys' },
            canActivate: [AuthGuard],
          },
          {
            path: "exit-survey/details",
            component: NewAdminRedirectComponent,
            data: { pageTitle: 'Exit surveys', pagePath: '/members?section=exit-surveys' },
            canActivate: [AuthGuard],
          },
          {
            path: "employers",
            component: NewAdminRedirectComponent,
            data: { pageTitle: "Employers", pagePath: "/businesses" },
            canActivate: [AuthGuard],
          },
          {
            path: "business-types",
            component: NewAdminRedirectComponent,
            data: { pageTitle: "Business Types", pagePath: "/business-types" },
            canActivate: [AuthGuard],
          },
          {
            path: "business-classifications",
            component: NewAdminRedirectComponent,
            data: { pageTitle: "Business Classifications", pagePath: "/business-classifications" },
            canActivate: [AuthGuard],
          },
          {
            path: "job-titles",
            component: NewAdminRedirectComponent,
            data: { pageTitle: "Job Titles", pagePath: "/job-titles" },
            canActivate: [AuthGuard],
          },
          {
            path: "management-levels",
            component: NewAdminRedirectComponent,
            data: { pageTitle: "Management Levels", pagePath: "/management-levels" },
            canActivate: [AuthGuard],
          },
          {
            path: "areas-of-business",
            component: NewAdminRedirectComponent,
            data: { pageTitle: "Areas of Business", pagePath: "/areas-of-business" },
            canActivate: [AuthGuard],
          },
        ],
      },
    ],
  },
  {
    path: "**",
    component: NewAdminRedirectComponent,
  },
];

export const routing = RouterModule.forRoot(appRoutes, {
  // useHash: true
});



// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/app/app.routing.ts